import { Table as AntdTable, TableProps as AntdTableProps } from "antd";
import { LoadingExtraLargeIcon } from "@/base/static/index";
import { ExpandIcon } from "./components/ExpandIcon.component";
import { CMP_PREFIX } from "@/base/constant";
import { ColumnType as AntdColumnType } from "antd/es/table";

export type TableColumnType<T> = AntdColumnType<T>;
export interface TableProps<RecordType = Record<PropertyKey, any>>
  extends AntdTableProps<RecordType> {}

export const tablePrefixCls = `${CMP_PREFIX}-table`;

export const Table = <RecordType,>({
  expandable,
  loading,
  ...props
}: TableProps<RecordType>) => {
  const getLoadingConfig = (config: AntdTableProps["loading"]) => {
    if (config === true) {
      return {
        spinning: true,
        indicator: <LoadingExtraLargeIcon spin />,
      };
    }

    return config;
  };

  return (
    <AntdTable<RecordType>
      loading={getLoadingConfig(loading)}
      expandable={{
        expandIcon: ExpandIcon,
        ...expandable,
      }}
      {...props}
    />
  );
};

Table.defaultExpandIcon = ExpandIcon;
export const TableSummaryCell = AntdTable.Summary.Cell;
export const TableSummaryRow = AntdTable.Summary.Row;
